import { takeEvery, all } from 'redux-saga/effects'
import doFetchTeams from './flows/do-fetch-teams'
import doFetchPlayers from './flows/do-fetch-players'
import { TOURNAMENT_LOAD_PLAYERS, TOURNAMENT_TEAMS } from './constants'

export function* watchTournamentPlayers() {
  yield all([takeEvery(TOURNAMENT_LOAD_PLAYERS, doFetchPlayers), takeEvery(TOURNAMENT_TEAMS, doFetchTeams)])
}
